import axios from "@/api/axiosInstance";
import { ArchiveLibraryModuleResponse } from "./types";

export const archiveLibraryModule = async (
  uuid: string,
): Promise<ArchiveLibraryModuleResponse> => {
  const response = await axios.delete<ArchiveLibraryModuleResponse>(
    `/api/private/learning-center/module-library/${uuid}`,
  );
  return response.data;
};
